import React, { useEffect, useState } from "react";
import Chart from "../../components/Charts/Chart";
import Navbar from "../../components/Navbar";
import DataMasuk from "../../components/Card/data-bulanan";
import { API_URL_PAY } from "../../config";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FaChartPie } from "react-icons/fa";
import { BsDatabaseFillCheck } from "react-icons/bs";
import { PiChartLineDownBold, PiChartLineUpBold } from "react-icons/pi";
import api from "../../config/api";
import LoadingSpinner from "../../components/Loading/loading";
import jwtDecode from "jwt-decode";

const Home = () => {
  const [namaUser, setNamaUser] = useState("");
  const [dataMonths, setDataMonths] = useState(null);
  const [dataDays, setDataDays] = useState(null);
  const [isLoadingMonth, setIsLoadingMonth] = useState(true);
  const [isLoadingDay, setIsLoadingDay] = useState(true);

  const [xaxisCategoriesMonth, setXaxisCategoriesMonth] = useState([]);
  const [xaxisCategoriesDay, setXaxisCategoriesDay] = useState([]);
  const [dataMonth, setDataMonth] = useState([]);
  const [dataDay, setDataDay] = useState([]);
  const [dataTotal, setDataTotal] = useState([]);

  useEffect(() => {
    const raw = localStorage.getItem("refToken");
    if (raw) {
      try {
        const decoded = jwtDecode(raw);
        setNamaUser(decoded.rows?.[0]?.namaUser || "Tidak ada nama");
      } catch (err) {
        console.error("Gagal decode token:", err);
      }
    }
  }, []);

  useEffect(() => {
    getDataMonth();
    getDataDay();
    getData();
  }, []);

  useEffect(() => {
    if (dataMonths) {
      setDataMonth([
        {
          name: "Total Data",
          data: dataMonths.totalData || [],
        },
      ]);
      setXaxisCategoriesMonth(dataMonths.labels || []);
      setIsLoadingMonth(false);
    }
  }, [dataMonths]);

  useEffect(() => {
    if (dataDays) {
      setDataDay([
        {
          name: "Total Data",
          data: dataDays.totalData || [],
        },
      ]);
      setXaxisCategoriesDay(dataDays.labels || []);
      setIsLoadingDay(false);
    }
  }, [dataDays]);

  const getData = async () => {
    try {
      const response = await api.get(`${API_URL_PAY}/mopsimapp/total-update`);
      setDataTotal(response?.data?.data || []);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Session expired, please login again.",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const getDataMonth = async () => {
    try {
      const response = await api.get(
        `${API_URL_PAY}/mopsimapp/total-sim5month`
      );
      setDataMonths(response.data?.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Session expired, please login again.",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const getDataDay = async () => {
    try {
      const response = await api.get(`${API_URL_PAY}/mopsimapp/total-sim5day`);
      setDataDays(response.data?.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Session expired, please login again.",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  return (
    <>
      <Navbar namaSamsat="" />
          <div className="min-h-screen h-full p-4 bg-gradient-to-b from-gray-100 to-sky-800">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4 items-center">
          <div className="md:col-span-2">
            <h1 className="text-xl font-semibold text-sky-800">
              Selamat datang {namaUser}!
            </h1>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Link
              to={"/outlet"}
              className="flex items-center justify-start gap-3 rounded-[10px] bg-amber-700 p-2 md:p-4 hover:scale-95"
            >
              <div className="flex p-2 items-center justify-center rounded-full bg-white">
                <BsDatabaseFillCheck size={28} color="#b45309" />
              </div>
              <span className="text-body-sm font-medium text-gray-300">
                Rekap Data Outlet
              </span>
            </Link>
            <Link
              to={"/sim"}
              className="flex items-center justify-start gap-3 rounded-[10px] bg-amber-700 p-2 md:p-4 hover:scale-95"
            >
              <div className="flex p-2 items-center justify-center rounded-full bg-white">
                <FaChartPie size={28} color="#b45309" />
              </div>
              <span className="text-body-sm font-medium text-gray-300">
                Rekap Jenis SIM
              </span>
            </Link>
          </div>
        </div>

        {/* Data Bulanan */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {dataTotal.length >= 2 && (
            <>
              <DataMasuk
                total={dataTotal[1].total}
                bulan="Bulan Kemarin"
                name={dataTotal[1].bulan}
                icon={
                  dataTotal[1].total > dataTotal[0].total ? (
                    <PiChartLineUpBold size={28} color="#115e59" />
                  ) : (
                    <PiChartLineDownBold size={28} color="#991b1b" />
                  )
                }
              />
              <DataMasuk
                total={dataTotal[0].total}
                bulan="Bulan Ini"
                name={dataTotal[0].bulan}
                icon={
                  dataTotal[0].total >= dataTotal[1].total ? (
                    <PiChartLineUpBold size={28} color="#115e59" />
                  ) : (
                    <PiChartLineDownBold size={28} color="#991b1b" />
                  )
                }
              />
            </>
          )}
        </div>

        {/* Chart */}
        <div className="grid grid-cols-1 md:grid-cols-2">
          {isLoadingDay ? (
            <LoadingSpinner />
          ) : (
            <Chart
              name="Data 5 Hari Terakhir"
              data={dataDay}
              xaxisCategories={xaxisCategoriesDay}
              buttonClick={getDataDay}
              isLoadingDay={isLoadingDay}
            />
          )}
          {isLoadingMonth ? (
            <LoadingSpinner />
          ) : (
            <Chart
              name="Data 5 Bulan Terakhir"
              data={dataMonth}
              xaxisCategories={xaxisCategoriesMonth}
              buttonClick={getDataMonth}
              isLoadingDay={isLoadingDay}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Home;
